import { render, staticRenderFns } from "./CitizenSurveysList.vue?vue&type=template&id=37000780"
import script from "./CitizenSurveysList.vue?vue&type=script&lang=js"
export * from "./CitizenSurveysList.vue?vue&type=script&lang=js"
import style0 from "./CitizenSurveysList.vue?vue&type=style&index=0&id=37000780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports